// Req 2 (2026-05-13): servicio de catalogo de monedas.
// Las monedas se usan en clientes (moneda_designada, moneda_extranjera),
// metodos de pago, proformas y facturas.
import api from "./axiosConfig";

// (2026-07-16 C9) Catálogo 5 — Tipo de Venta, para el selector de la proforma.
// Endpoint público (sin auth): devuelve { valores: [{ codigo, id, valor }] }.
// El `codigo` ('01'..'04') es lo que el docElectronico lleva en `tipoDeVenta`.
export const getTiposVenta = async () => {
  try {
    const response = await api.get("/api/catalogos/tipo-venta");
    return response.data?.valores || [];
  } catch (error) {
    console.error("Error al obtener tipos de venta:", error);
    return [];
  }
};

// Listado. Por defecto trae todas; pasa { activo: true } para filtrar.
export const getMonedas = async (filters = {}) => {
  try {
    const params = {};
    if (filters.activo != null) params.activo = String(filters.activo);
    const response = await api.get("/api/monedas", { params });
    // El endpoint devuelve { data: [...] }
    return response.data;
  } catch (error) {
    console.error("Error al obtener monedas:", error);
    throw error;
  }
};

export const showMoneda = async (id) => {
  try {
    const response = await api.get(`/api/monedas/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error al consultar moneda:", error);
    throw error;
  }
};

export const createMoneda = async (body) => {
  try {
    const response = await api.post("/api/monedas", body);
    return response.data;
  } catch (error) {
    console.error("Error al crear moneda:", error);
    throw error;
  }
};

export const editMoneda = async (id, body) => {
  try {
    const response = await api.put(`/api/monedas/${id}`, body);
    return response.data;
  } catch (error) {
    console.error("Error al editar moneda:", error);
    throw error;
  }
};

export const deactivateMoneda = async (id) => {
  try {
    const response = await api.delete(`/api/monedas/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error al desactivar moneda:", error);
    throw error;
  }
};

// Helper: extrae el array data del response (tolerante a respuesta directa).
export const normalizeMonedasResponse = (resp) => {
  if (Array.isArray(resp)) return resp;
  if (resp && Array.isArray(resp.data)) return resp.data;
  return [];
};
